/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from "../../api";
import {Injectable} from '@angular/core';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class ReportTranslationDefaultsResource {
  private readonly uri: string = ApiConfig.obtain().getVersionedUri('reporttranslationdefaults');
  private readonly send: AdnHttpSender;

  reportTranslationDefaults: any;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get() {
    return this.reportTranslationDefaults ? Promise.resolve(this.reportTranslationDefaults) : this.send({
      method: 'GET',
      url: this.uri,
      params: {context: null}
    }).then((data) => {
      this.reportTranslationDefaults = data;
      return this.reportTranslationDefaults;
    });
  }
}
